<template>
    <Modal v-model="visible" width="460px" title="新增" :footer-hide="true" :mask-closable="false" class="my-modal top">
        <Form ref="form" :model="formData" :label-width="110" class="page-form">
            <FormItem prop="organId" label="所属机构" class="full" :rules="$units.formRule.required('请选择所属机构', 'change')">
                <selectTree type="3" v-model="organId" @change="selectTreeChange"></selectTree>
            </FormItem>
            <FormItem prop="groupId" label="所属团队" class="full" :rules="$units.formRule.required('请选择所属团队')">
                <Select v-model="formData.groupId" filterable @on-change="getUserList()">
                    <Option v-for="(bean, i) in groupList" :key="i" :value="bean.groupId">{{ bean.groupName }}</Option>
                </Select>
            </FormItem>
            <FormItem prop="userId" label="业务员姓名" class="full" :rules="$units.formRule.required('请选择业务员')">
                <Select v-model="formData.userId" filterable @on-change="selectUser">
                    <Option v-for="(bean, i) in userList" :key="i" :value="bean.id">{{ bean.name }}</Option>
                </Select>
            </FormItem>

            <FormItem prop="remark" label="当前职级" class="full">
                {{ userinfo.rankName || '-' }}
            </FormItem>
            <FormItem prop="newRankId" label="变更职级" class="full" :rules="$units.formRule.required('请选择变更职级')">
                <Select v-model="formData.newRankId" filterable transfer>
                    <Option v-for="(bean, i) in rankList" :key="i" :value="bean.id" v-if="userinfo.rankId != bean.id">{{
                        bean.name
                    }}</Option>
                </Select>
            </FormItem>
            <FormItem prop="reason" label="变更原因" class="full">
                <Input v-model="formData.reason" placeholder="请输入" type="textarea" />
            </FormItem>
        </Form>
        <div class="ivu-modal-footer">
            <Button type="text" @click="visible = false">取消</Button>
            <Button type="primary" @click="submit" :loading="loading">提交</Button>
        </div>
    </Modal>
</template>

<script>
import selectTree from '@/components/system/selectTree3';
export default {
    components: {
        selectTree
    },
    props: [],
    data() {
        return {
            visible: false,
            loading: false,
            organId: [],
            formData: {
                organId: '',
                groupId: '',
                newRankId: '',
                userId: '',
                remark: ''
            },
            userinfo: {},
            userList: [], //业务员列表
            rankList: [], //职级列表
            groupList: [] //团队列表
        };
    },
    created() {},
    methods: {
        open(data = {}) {
            this.userinfo = {};
            this.organId = [];
            this.visible = true;
            this.getRankList();
            this.$refs.selectTreeRef && this.$refs.selectTreeRef.init();
            this.$refs.form && this.$refs.form.resetFields();
        },
        // 组织选择
        selectTreeChange() {
            console.log(this.organId);
            if (this.organId == this.formData.organId) {
                //避免重复触发
                return;
            }
            this.$set(this.formData, 'organId', this.organId);
            this.$set(this.formData, 'groupId', '');
            this.$set(this.formData, 'userId', '');
            this.userList = [];
            this.getGroupList(this.formData.organId);
        },
        // 选择用户
        selectUser(id) {
            const user = this.userList.find(item => {
                return id == item.id;
            });
            if (user && user.id) {
                this.userinfo = user;
            } else {
                this.userinfo = {};
            }
        },
        // 获取团队列表
        getGroupList(id) {
            this.$http({
                url: '/buz/organizationGroup/getSubGroup',
                type: 'get',
                data: {
                    organizationId: id
                }
            }).then(res => {
                this.groupList = res.data;
            });
        },
        // 业务员列表
        getUserList() {
            this.$set(this.formData, 'userId', '');
            this.$http({
                url: '/buz/userBase/queryByName',
                type: 'get',
                data: {
                    organizationId: this.formData.organId,
                    groupId: this.formData.groupId,
                    userName: ''
                }
            }).then(res => {
                this.userList = res.data;
            });
        },
        //获取职级
        getRankList() {
            this.$http({
                url: '/buz/baseRank/read/all',
                type: 'POST',
                data: {}
            }).then(res => {
                this.rankList = res.data;
            });
        },

        submit() {
            console.log('validate');
            this.$refs.form.validate().then(isok => {
                if (!isok) {
                    return;
                }
                const formData = JSON.parse(JSON.stringify(this.formData));
                formData.oldRankId = this.userinfo.rankId;
                formData.promotionType = 0;
                if (this.loading) {
                    return;
                }
                this.loading = true;
                this.$http({
                    type: 'POST',
                    url: '/buz/userRankChangeRecord/change',
                    data: formData
                })
                    .then(res => {
                        // if(res.data) {
                        //   this.submitAjax(formData);
                        // }else{
                        //   this.$notice.inquiry("请确认是否更改此业务员职级，更改后基本法职级费用计算从下个月生效").then(() => {
                        //     this.submitAjax(formData);
                        //   }).catch(()=>{
                        this.loading = false;
                        this.$emit('reload');
                        this.$notice.success('提交成功');
                        this.visible = false;
                        // });
                        // }
                    })
                    .catch(res => {
                        this.loading = false;
                    });
            });
        },
        // 验证用户是否绑定基本法
        submitAjax(formData) {
            this.$http({
                type: 'POST',
                url: '/buz/userPromotionRecord/add',
                data: formData,
                apiPermissionCode:'org_3_5'
            })
                .then(res => {
                    this.$notice.success('提交成功');
                    this.visible = false;
                    this.$emit('reload');
                })
                .finally(res => {
                    this.loading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped></style>
